<template>
  <div>
    <!--begin::Dashboard-->
    <!--begin::Row-->
    <div class="row">
      <div class="col-xl-8">
        <!--begin::Charts Widget 6-->
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header justify-content-center">
            <div class="card-title py-5">
              <h3 class="card-label">
                <span class="d-block text-dark font-weight-bolder"
                  ><p>{{ $t("dashboard.analytics_title") }}</p></span
                >
              </h3>
            </div>
          </div>
          <!--end::Header-->

          <!--begin::Body-->
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 d-flex flex-column mb-5 mb-md-0">
                <!--begin::Block-->
                <div class="bg-light-warning p-8 rounded-xl flex-grow-1">
                  <!--begin::Item-->
                  <div
                    class="d-flex align-items-center mb-5"
                    v-b-popover.hover.top="$t('dashboard.total_users')"
                  >
                    <div
                      class="symbol symbol-circle symbol-white symbol-30 flex-shrink-0 mr-3"
                    >
                      <div class="symbol-label">
                        <span class="svg-icon svg-icon-md svg-icon-danger"
                          ><i class="flaticon-users-1 text-danger"></i
                        ></span>
                      </div>
                    </div>
                    <div>
                      <div class="font-size-sm font-weight-bold">
                        {{ patientsCountAll }}
                      </div>
                      <div class="font-size-sm text-muted">
                        {{ $t("dashboard.total_users") }}
                      </div>
                    </div>
                  </div>
                  <!--end::Item-->
                  <!--begin::Item-->
                  <div
                    class="d-flex align-items-center mb-5"
                    v-b-popover.hover.top="$t('dashboard.number_of_users')"
                  >
                    <div
                      class="symbol symbol-circle symbol-white symbol-30 flex-shrink-0 mr-3"
                    >
                      <div class="symbol-label">
                        <span class="svg-icon svg-icon-md svg-icon-warning"
                          ><i class="flaticon-network text-success"></i
                        ></span>
                      </div>
                    </div>
                    <div>
                      <div class="font-size-sm font-weight-bold">
                        {{ patientsCount }}
                      </div>
                      <div class="font-size-sm text-muted">
                        {{ $t("dashboard.number_of_users") }}
                      </div>
                    </div>
                  </div>
                  <!--end::Item-->

                  <!--begin::Item-->
                  <div
                    class="d-flex align-items-center mb-5"
                    v-b-popover.hover.top="$t('dashboard.profit_popover')"
                  >
                    <div
                      class="symbol symbol-circle symbol-white symbol-30 flex-shrink-0 mr-3"
                    >
                      <div class="symbol-label">
                        <span class="svg-icon svg-icon-md svg-icon-info"
                          ><i class="flaticon-piggy-bank text-primary"></i
                        ></span>
                      </div>
                    </div>
                    <div>
                      <div class="font-size-sm font-weight-bold">
                        {{ income }}
                      </div>
                      <div class="font-size-sm text-muted">
                        {{ $t("dashboard.profit") }}
                      </div>
                    </div>
                  </div>
                  <!--end::Item-->
                  <hr />
                  <!--begin::Item-->
                  <div class="d-flex align-items-center mb-5">
                    <div
                      class="symbol symbol-circle symbol-white symbol-30 flex-shrink-0 mr-3"
                    >
                      <div class="symbol-label">
                        <span class="svg-icon svg-icon-md svg-icon-warning"
                          ><i class="flaticon-price-tag text-warning"></i
                        ></span>
                      </div>
                    </div>
                    <div>
                      <div class="font-size-sm font-weight-bold">
                        {{ price }}
                      </div>
                      <div class="font-size-sm text-muted">
                        {{ $t("dashboard.price_per_game") }}
                        <a
                          v-b-modal.modal-edit-price
                          data-toggle="modal"
                          data-target="#editPriceGame"
                          class="label-lg ml-2"
                          ><span class="flaticon-edit"></span
                        ></a>
                      </div>
                    </div>
                  </div>
                  <!--end::Item-->
                </div>
                <!--end::Block-->
              </div>
              <div class="col-md-8">
                <apexchart
                  ref="usersChart"
                  :options="usersChartOptions"
                  :series="dataUsers"
                  type="area"
                ></apexchart>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Charts Widget 6-->
      </div>

      <div class="col-xl-4">
        <!--begin::Card-->
        <div class="card card-custom gutter-b mb-0">
          <div class="card-header justify-content-center">
            <div class="card-title">
              <span class="d-block text-dark font-weight-bolder">
                {{ $t("dashboard.download_count_title") }}</span
              >
            </div>
          </div>
          <div class="card-body">
            <!--begin::Chart-->
            <apexchart
              ref="gamesChart"
              :options="gamesChartOptions"
              :series="dataGames"
              :total="dataGamesSum"
              type="donut"
            ></apexchart>
            <!--end::Chart-->
          </div>
        </div>
        <!--end::Card-->
      </div>
    </div>
    <!--end::Row-->
    <!--end::Dashboard-->
    <b-modal
      id="modal-edit-price"
      ref="modal-edit-price"
      :title="$t('dashboard.edit_price')"
    >
      <form v-on:submit.prevent>
        <div class="form-group">
          <label>{{ $t("dashboard.price_per_game") }}</label>
          <input
            v-int
            type="text"
            class="form-control"
            maxlength="6"
            v-model.trim="price"
            :class="{
              invalid:
                ($v.price.$dirty && !$v.price.required) ||
                ($v.price.$dirty && !$v.price.maxLength)
            }"
          />
          <span
            v-if="$v.price.$dirty && !$v.price.required"
            class="helper-text invalid"
            >{{ $t("dashboard.enter_price") }}</span
          >
          <small
            class="helper-text invalid"
            v-else-if="$v.price.$dirty && !$v.price.maxLength"
          >
            {{ $t("dashboard.max_length") }}
            {{ $v.price.$params.maxLength.max }}
          </small>
        </div>
      </form>

      <template #modal-footer="{cancel, ok}">
        <b-button variant="secondary" @click="cancel()">
          {{ $t("dashboard.cancel") }}
        </b-button>

        <b-button variant="primary" @click="handleSubmitEditPrice()">
          {{ $t("dashboard.save") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapActions, mapGetters } from "vuex";
//import ru from "apexcharts/dist/locales/ru.json";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module.js";
import { required, maxLength } from "vuelidate/lib/validators";

const primary = "#6993FF";
const danger = "#F64E60";

export default {
  name: "dashboard",

  data() {
    return {
      price: 0,
      patientsCount: 0,
      patientsCountAll: 0,
      income: 0,
      incomeAll: 0,
      doctor: {},
      dataGamesSum: 0,
      usersChartOptions: {},
      gamesChartOptions: {},
      active_gamers_stat: {},
      dataGames: [0, 0, 0, 0, 0],
      dataUsers: [
        {
          name: "Active",
          data: []
        },
        {
          name: "Not active",
          data: []
        }
      ],
      gamesCategories: [" Ball", " Spider", " Crosses", " Puzzle"],
      usersCategories: []
    };
  },
  validations: {
    price: { required, maxLength: maxLength(6) }
  },
  computed: {
    ...mapGetters([
      "layoutConfig",
      "getDoctor",
      "getUserId",
      "getActivePatientCount",
      "getPatientCount",
      "getDownloadGamesCount",
      "getSumDownloadGamesCount",
      "getActiveGamersStat"
    ])
  },

  async mounted() {
    var d = document.getElementById("kt_aside_tab_1");
    d.className += " btn-clean active";
    this.dataUsers[0].name = this.$t("dashboard.active");
    this.dataUsers[1].name = this.$t("dashboard.not_active");

    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);

    await this.updateData();
    this.gamesChartOptions = {
      chart: {},
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ],
      plotOptions: {
        pie: {
          startAngle: 0,
          expandOnClick: true,
          offsetX: 0,
          offsetY: 0,
          customScale: 1,
          dataLabels: {
            offset: 0,
            minAngleToShowLabel: 10
          },
          donut: {
            size: "65%",
            background: "transparent",
            labels: {
              show: true,
              name: {
                show: true,
                color: undefined,
                offsetY: 0,
                formatter: function(val) {
                  return val;
                }
              },
              value: {
                show: true,
                color: undefined,
                offsetY: 16,
                formatter: function(val) {
                  return val;
                }
              },
              total: {
                show: true,
                showAlways: false,
                label: this.$t("dashboard.total"),
                formatter: function(w) {
                  return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                }
              }
            }
          }
        }
      },

      labels: this.gamesCategories
    };
    this.usersChartOptions = {
      chart: {
        height: 350,

        zoom: {
          enabled: true
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "smooth"
      },
      xaxis: {
        categories: this.usersCategories
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm"
        }
      },
      colors: [primary, danger]
    };

    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
  },
  methods: {
    ...mapActions([
      "fetchDoctorById",
      "updateDoctor",
      "fetchPatientsByDoctorId",
      "fetchActiveGamersStatByDoctorId"
    ]),
    async handleSubmitEditPrice() {
      try {
        if (this.$v.$invalid) {
          this.$v.$touch();
          return;
        }
      } catch (e) {
        return;
      }
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      this.$refs["modal-edit-price"].hide();
      this.doctor.price = this.price;
      await this.updateDoctor(this.doctor);
      await this.updateData();
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    },
    async updateData() {
      await this.fetchDoctorById(this.getUserId);
      await this.fetchPatientsByDoctorId(this.getUserId);
      await this.fetchActiveGamersStatByDoctorId(this.getUserId);

      this.dataGames = this.getDownloadGamesCount;
      this.dataGamesSum = this.getSumDownloadGamesCount;
      this.doctor = this.getDoctor;
      this.price = this.doctor.price;
      this.patientsCountAll = this.getPatientCount;
      this.patientsCount = this.getActivePatientCount;
      this.income = this.price * this.patientsCount;
      this.incomeAll = this.price * this.patientsCountAll;

      this.active_gamers_stat = this.getActiveGamersStat;

      this.active_gamers_stat.forEach(item => {
        this.dataUsers[0].data.push(item.active_count);
        this.dataUsers[1].data.push(item.not_active_count);
        this.usersCategories.push(item.date);
      });
    }
  }
};
</script>
